import $ from 'jquery'
import '../scss/module_app.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { firebaseIsSignInWithEmailLink, initFirebaseApp } from './module_firebase';
import { manageLogin, manageLoginFromEmailLink } from './module_auth_helper';

import {
    attachTryPremiumSubscribe,
    funnelUpdateWhenAvailable,
    manageWelcomeGuestPremium,
} from './module_common';

import {
    defaultCarouselSetupNew,
    defaultCarouselSetupTwoRow,
} from './module_swiper';

import {configBookCard} from './module_book_card';
import {configArticleCard} from './module_article_card';

import { initCardLazyLoad } from './module_lazyload';

import { initNavbar } from './module_header';

import './module_common_actions';
import { initSentry } from './module_sentry';

const serieCarouselSetUp = function(){
    const out = "bookserie-out"
    const container = "bookserie-swiper-container"
    defaultCarouselSetupNew(container, out, 'auto', 4, 4, 4, searchCardsEndPoint)
}
const newsCarouselSetUp = function(){
    const out = "news-out"
    const container = "news-swiper-container"
    defaultCarouselSetupNew(container, out, 'auto', 4, 5, 7)  
}
const recommendedCarouselSetUp = function(){
    const out = "recommended-out"
    const container = "recommended-swiper-container"
    defaultCarouselSetupNew(container, out, "auto", 4, 5, 7, searchCardsEndPoint)
}
const continueWithCarouselSetUp = function(){
    const out = "continueWith-out"
    const container = "continueWith-swiper-container"
    defaultCarouselSetupNew(container, out, 'auto', 4, 5, 7, searchCardsEndPoint)
}
const skillCarouselSetUp = function(){
    const out = "skills-out"
    const container = "skills-swiper-container"
    defaultCarouselSetupNew(container, out, "auto", 3, 3, 4, searchCardsEndPoint)  
}
const categoriesCarouselSetUp = function(){
    const out = "categories-out"
    const container = "categories-swiper-continer"
    defaultCarouselSetupNew(container, out, 'auto', 'auto', 1, 1)  
}
const mostViewedCarouselSetUp = function(){
    const out = "mostviewed-out"
    const container = "mostviewed-swiper-container"
    defaultCarouselSetupNew(container, out, 'auto', 4, 5, 7)
}
const favouritesCategoryCarouselSetup = function(){
    $("div[class*=' favout-']").each(function(){
        const container = $(this).data('containerclass')
        const out = $(this).data('outclass')
        defaultCarouselSetupNew(container, out, 'auto', 4, 5, 7, searchCardsEndPoint)
    })   
}
function podcastsCarouselSetUp() {
    const out = "podcasts-out"
    const container = "podcasts-swiper-container"
    defaultCarouselSetupNew(container, out, "auto", 3, 4, 5, searchCardsEndPoint)  
}
function articleNewsCarouselSetUp() {
    const out = "article-news-out"
    const container = "article-news-swiper-container"
    defaultCarouselSetupTwoRow(container, out, 'auto', 2, 3, searchCardsEndPoint)
}

function manageVerifyEmailLink(){
    if (firebaseIsSignInWithEmailLink(window.location.href)){
        if (velEmail !== '') manageLoginFromEmailLink(velEmail)
    }
}

document.addEventListener("DOMContentLoaded", () => {
    initSentry()
    initFirebaseApp()
    manageLogin()

    // do it after do_last call
    manageWelcomeGuestPremium()

    manageVerifyEmailLink()

    doLast()
    initCardLazyLoad()
    
    initNavbar()

    // Free book in page top, for visitor and free user use same player class as cards
    configBookCard()
    configArticleCard()

    serieCarouselSetUp()
    newsCarouselSetUp()
    recommendedCarouselSetUp()
    continueWithCarouselSetUp()
    skillCarouselSetUp()
    categoriesCarouselSetUp()
    mostViewedCarouselSetUp()
    favouritesCategoryCarouselSetup()
    podcastsCarouselSetUp()
    articleNewsCarouselSetUp()

    attachTryPremiumSubscribe()

    if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('home_viewed');
});